// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3pEUD","container":"styles_container__2XowS","title":"styles_title__1yw3L","wrapper":"styles_wrapper__1ImDl","answer":"styles_answer__2i_gi"};